module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/02-990e8595705ffdf0c6d3561ccbc12cad.jpg";